import { useNavigate } from 'react-router-dom';

import {
  ArchiveBoxIcon,
  ArrowUturnLeftIcon,
  EllipsisHorizontalIcon
} from '@heroicons/react/24/outline';
import { Button } from '@oysterjs/ui/button';
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '@oysterjs/ui/dropdown';

/**
 * Title row of a list page with an archived twin at `${basePath}/archived`: an
 * overflow menu into the archived view, and a plain way back from it. Lives in
 * PageTitle's `title` because its `menu` slot stacks below the title on narrow screens.
 */
export const ArchivedViewTitle = ({
  archived,
  title,
  archivedTitle,
  basePath,
  noun
}: {
  archived: boolean;
  title: string;
  archivedTitle: string;
  basePath: string;
  /** Plural, lower case: "View archived {noun}" / "Back to {noun}". */
  noun: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="min-w-0 truncate">{archived ? archivedTitle : title}</span>
      <span className="flex-shrink-0">
        {archived ? (
          <Button plain className="whitespace-nowrap" onClick={() => navigate(basePath)}>
            <ArrowUturnLeftIcon className="size-4" />
            Back to {noun}
          </Button>
        ) : (
          <Dropdown>
            <DropdownButton plain aria-label="More options">
              <EllipsisHorizontalIcon className="size-5" />
            </DropdownButton>
            <DropdownMenu anchor="bottom end">
              <DropdownItem onClick={() => navigate(`${basePath}/archived`)}>
                <ArchiveBoxIcon data-slot="icon" />
                View archived {noun}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        )}
      </span>
    </div>
  );
};
